const r = (t, e = "text") => e === "text" ? `var(--hr-font-size-${t})` : `var(--hr-font-size-display-${t})`, a = (t, e = "text") => e === "text" ? `var(--hr-line-height-${t})` : `var(--hr-line-height-display-${t})`, i = (t) => `var(--hr-font-weight-${t})`;
export {
  r as createFontSizeVariables,
  i as createFontWeightVariables,
  a as createLineHeightVariables
};
